import type { StoryComment } from '~/common/types/story-comment';
import type { CommentsResult } from '@app/(default-layout)/s/[storyId]/_containers/comments-detail-container/requests/get-comments-list';

export const createLikeOrUnlikeOptimisticData = (
  comment: StoryComment,
  commentsResult: CommentsResult[] | undefined
): CommentsResult[] | undefined => {
  return commentsResult?.flatMap((result) => {
    const comments = result.comments.some((c) => c.id === comment.id)
      ? result.comments.map((c) => {
          if (c.id === comment.id) {
            return {
              ...c,
              likedByMe: !comment.likedByMe,
              likeCount: comment.likedByMe ? c.likeCount - 1 : c.likeCount + 1,
            };
          }
          return c;
        })
      : result.comments;

    return {
      ...result,
      comments,
    };
  });
};

export const getPostReplyKey = (parentCommentId: string) =>
  `comment-reply/${parentCommentId}/posted`;
